import React from 'react';
import './svg-icon.styles.scss';

const SvgIcon = (props) => {
	const { icon, iconclass, width, height } = props;
	return (
		<svg className={`icon ${iconclass ? iconclass : icon}`} style={{ width: width, height: height }}>
			<use xlinkHref={`/assets/icons-v6.svg#${icon}`} />
		</svg>
	);
};

export default SvgIcon;
